import axios from 'axios'

// const headers = {
//     "Content-Type": "application/json",
//     Authorization: `Bearer ${accessToken}`,
//     //"Access-Control-Allow-Origin": "*", // Add CORS header
//     //"Access-Control-Allow-Credentials": "true",
//     //"Access-Control-Allow-Headers": "Content-Type, Authorization"
// };

export const axiosInstance = axios.create({
    headers: {
        "Content-Type": "application/json"
    },
    //timeout: 300000
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        const accessToken = localStorage.getItem("localaccesstoken");
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
